module.exports = __webpack_public_path__ + "img/dangerHubHeader3.52ba6bf3.png";